import { render, staticRenderFns } from "./DropPoints.vue?vue&type=template&id=7b598fb1&scoped=true&lang=html"
import script from "./DropPoints.vue?vue&type=script&lang=js"
export * from "./DropPoints.vue?vue&type=script&lang=js"
import style0 from "./DropPoints.vue?vue&type=style&index=0&id=7b598fb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b598fb1",
  null
  
)

export default component.exports